export default function generateAnimationName(id) {
  return "k" + id;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/generateAnimationName.js
// module id = 720
// module chunks = 0